export const GO_TO_SETTING = 'GO_TO_SETTING';

export const SET_DATA_SOURCE = 'SET_DATA_SOURCE';

export const RESET_DATA_SOURCE = 'RESET_DATA_SOURCE';

export const SET_TEMP_VALUE = 'SET_TEMP_VALUE';

export const SET_TEMP_POWER_VALUE = 'SET_TEMP_POWER_VALUE';

export const SET_LEFTMENU_DATA = 'SET_LEFTMENU_DATA';

export const SET_TEMP_DATA_SOURCE = 'SET_TEMP_DATA_SOURCE';

export const SET_ADD_GROUP_SOURCE = 'SET_ADD_GROUP_SOURCE';

export const SET_ADD_GROUP_TEMP_VALUE = 'SET_ADD_GROUP_TEMP_VALUE';

export const RESET_ADD_GROUP_SOURCE = 'RESET_ADD_GROUP_SOURCE';

export const RESET_OPERATE_GROUP = 'RESET_OPERATE_GROUP';

export const SET_OPERATE_GROUP = 'SET_OPERATE_GROUP';

export const SET_EDIT_RECORD = 'SET_EDIT_RECORD';

export const SET_PLAN_NAME = 'SET_PLAN_NAME';



// WEBPACK FOOTER //
// ./src/vuex/modules/mutationTypes.js